<template>
    <div class="reputation-modal arrow-box" v-bind:class="{'dark': theme === 'dark'}">
        <div class="close-button" v-on:click="hideModal">
            <i class="fas fa-times"></i>
        </div>
        <h5>
            What is Guestflip Rating
        </h5>
        <div class="guestflip-description">
            The GuestFlip rating is calculated based on real guest reviews from over 50 platforms.
            <br>
            <br>
            This rating is calculated by collecting millions of confirmed guest reviews from all countries.
            <br>
            <br>
            <a href="https://guestflip.io" target="_blank">GuestFlip</a> offers review management solutions for hospitality businesses and this rating is calculated independently by GuestFlip.
            <br>
            <br>
            <strong>GuestFlip</strong> affirms that the data displayed is accurate and verified by our validation mechanisms.
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ReputationModal',
        props: ['data', 'widgetId', 'theme'],
        data: function() {
            return {
            }
        },
        methods: {
            hideModal() {
                const urlParams = new URLSearchParams(window.location.search);
                const iframeID = urlParams.get('iframeID');

                window.top.postMessage({event: 'closeModal', id: iframeID}, "*")
            }
        },
        async mounted() {
            const urlParams = new URLSearchParams(window.location.search);
            const iframeID = urlParams.get('iframeID');

            setInterval(function () {
                // first parameter is the message to be passed
                // second paramter is the domain of the parent
                // in this case "*" has been used for demo sake (denoting no preference)
                // in production always pass the target domain for which the message is intended
                window.top.postMessage({event: 'updateHeight', scrollHeight: document.body.scrollHeight, id: iframeID}, "*")
            }, 100);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import url('https://fonts.googleapis.com/css?family=Open+Sans');
    .reputation-modal strong {
        font-weight: bold !important;
    }
    .reputation-modal {
        position: relative;
        margin-left: 20px;
        font-family: 'Open Sans', sans-serif;;
        display: flex;
        flex-direction: column;
        padding: 18px 20px;
        width: 210px;
        border: 1px #212b3c solid;
        border-radius: 5px;
        background: #212b3c;
        color: white;
        font-weight: bold;
    }
    .reputation-modal a {
        color: #00afef;
    }
    .reputation-modal h3 {
        font-size: 13px;
    }
    .close-button {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        font-weight: normal;
    }
    .reputation-modal.dark {
        border-color: white;
        background: white;
        color: black
    }
    .reputation-modal .guestflip-description {
        padding-top: 10px;
        font-size: 13px;
        font-weight: normal;
        line-height: 1.3;
    }
    .reputation-modal.arrow-box:after, .reputation-modal.arrow-box:before {
        right: 98.8%;
        top: 57px;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
    }

    .reputation-modal.arrow-box:after {
        border-color: rgba(136, 183, 213, 0);
        border-right-color: #212b3c;
        border-width: 10px;
        margin-top: -40px;
    }
    .reputation-modal.dark.arrow-box:after {
        border-color: rgba(136, 183, 213, 0);;
        border-right-color: white;
    }
</style>
